import invariant from "tiny-invariant";
export const syncQueryBus = ({ queryDefinitions, queryBus }) => async (query, signal) => {
    invariant(queryDefinitions[query.name], `There is no subscribed QueryHandler for the provided Query - ${query.name}`);
    const [queryHandler, dependencies] = queryDefinitions[query.name];
    return queryHandler({ ...dependencies, queryBus: queryBus(), signal })(query);
};
